import isArray from 'lodash/isArray';
import iconv from 'iconv-lite';

export const prepareResponse = async (response, isBlobType) => {
  if (!isBlobType) {
    return response.data;
  }

  const type = response.headers['content-type'] || '';

  const header = response.headers['content-disposition'];
  const regex = new RegExp('filename[^;=\\n]*=(([\'"]).*?\\2|[^;\\n]*)');
  const matches = header && header.match(regex);
  let filename = null;
  if (matches != null && matches[1]) {
    iconv.skipDecodeWarning = true;
    filename = iconv.decode(matches[1].replace(/['"]/g, ''), 'UTF-8');
  }

  if (
    !filename &&
    (type.startsWith('application/json') || type.startsWith('text/html'))
  ) {
    return await new Promise(resolve => {
      const fr = new FileReader();
      fr.onload = evt => resolve(JSON.parse(evt.target.result));
      fr.readAsText(response.data);
    });
  }

  return {
    status: 'OK',
    data: { filename, type, file: new Blob([response.data]) },
  };
};

export const prepareError = async (error, isBlobType) => {
  if (
    !error.response ||
    !error.response.status ||
    (error.response.status !== 403 && error.response.status !== 404)
  ) {
    throw error;
  }

  if (!isBlobType) {
    const {
      status = null,
      data: { data = {} },
    } = error.response;

    return {
      status: error.response.data.status,
      data: { ...data, code: status },
    };
  }

  if (
    !error.response.headers ||
    error.response.headers['content-type'] !== 'application/json'
  ) {
    throw error;
  }

  return await new Promise(resolve => {
    const fr = new FileReader();
    fr.onload = evt =>
      resolve({
        status: 'ERROR',
        data: {
          ...JSON.parse(evt.target.result),
          code: error.response.status,
        },
      });
    fr.readAsText(error.response.data);
  });
};

export const preparePostParams = params => {
  const data = new FormData();
  Object.keys(params).forEach(fieldName => {
    const value = params[fieldName];
    if (isArray(value)) {
      if (value.length > 0) {
        value.forEach(v => {
          data.append(`${fieldName}[]`, v);
        });
      } else {
        console.log('Warn: Array replaced with null!');
        data.append(`${fieldName}`, '');
      }
    } else {
      data.append(fieldName, value);
    }
  });

  return data;
};
